<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="foreword">
<h1>Foreword</h1>
<p>The opportunity to finally compose this true story came during the Coronavirus pandemic and the 75<sup>th</sup> anniversary of VE Day. It seemed an appropriate time to compile in parallel two accounts of the WW2 Arctic maritime conflict. This was a war that any participant was very fortunate to survive; battling the enemy and also the sea and elements. The two narrators are my father, John or “Jack” Shirley, a second lieutenant in the Royal Navy serving on the corvette <em>K-405</em> <em>Alnwick Castle</em> and the Mechanical Engineer, Herbert Lochner, serving on the U-boat <em>U-425</em>. This is a story of their relative experiences of war from a very young age; both were close to their 18<sup>th</sup> birthdays in 1940, through to their relative survival of the war, with a common conclusion, that they were the “lucky” ones.</p>
<p>It seemed to make sense to start with my father’s account up to the sinking of <em>U-425</em>. I have then introduced Herbert Lochner’s account prior to the sinking. The two accounts of the sinking are then presented in parallel when both their worlds ‘collided’. Finally, their separate accounts following this event that brought them together and their separate histories to the end of the European conflict are included.</p>
<p>It remains to sincerely remember those on both sides that died in this conflict and pray that there is no repeat in any of our future generation’s lifetimes.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?367f8348